import { externalCourseParticipantsListWatcherSaga } from './list.saga'
import { destroyExternalCourseParticipantWatcherSaga } from './destroy.saga'
import { externalDestroyExternalCourseParticipantsSaga } from './destroyMany.saga'

export const root = [
  externalCourseParticipantsListWatcherSaga(),
  destroyExternalCourseParticipantWatcherSaga(),
  externalDestroyExternalCourseParticipantsSaga(),
]

export default root
